<template>
  <div>
    <!-- Update Uniform -->
    <div
      class="modal fade"
      id="addUniform_Modal"
      role="dialog"
      aria-labelledby="addUniform_Modal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header border-0">
            <h6 class="modal-title" id="addUniform_ModalLabel">
              Player Info
            </h6>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeModalUniform"
            >
              <img src="../../../../assets/Svg/close.svg" />
            </button>
          </div>
          <div class="modal-body">
            <div class="row no-gutters">
              <div class="team-details mb-3 w-100 justify-content-start pt-0">
                <div class="team-image position-relative">
                  <div class="users-notification" v-if="imgLoader == 1">
                    <img src="../../../../assets/loader.gif" alt="" />
                  </div>
                  <img
                    @load="onImageLoad"
                    :src="getUserImageUrl(userChatId)"
                    @error="handleImageError($event)"
                    alt=""
                  />
                </div>
                <div class="team-name-role">
                  <h6
                    :id="userChatId?.member?.user_link"
                    class="d-flex align-items-center"
                    style="gap: 5px;"
                  >
                    <router-link
                      class="user-name mx-0"
                      :to="'/profile/' + userChatId?.member?.user_link"
                    >
                      {{ userChatId?.member?.name }}
                    </router-link>
                    <span v-if="userChatId?.user_profile?.nick_name" class="m-0"
                      >({{ userChatId?.user_profile?.nick_name }} )</span
                    >
                  </h6>
                  <span v-if="userChatId.admin == '1'">Admin</span>
                  <p v-if="userChatId.admin == '0'"></p>
                  <span v-if="userChatId.fan == '1'">Fan</span>
                </div>
              </div>
              <div class="col-12 player-heading">
                <h6>Mark as Player</h6>
                <toggle-button
                  class="m-0"
                  v-model="isPlayer"
                  :value="false"
                  :sync="true"
                  :width="34"
                  @change="updateIsPlayer"
                />
              </div>
              <div class="col-12 player-tag">
                Users with player status will appears in game lineup, roster,
                and for keeping stats.
              </div>
              <div class="w-100" v-if="isPlayer">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    id="uniform"
                    v-model="uniform"
                    @keyup="errorNull"
                    @input="handleInputChange()"
                    required
                    maxlength="2"
                    :class="{
                      'is-invalid': $v.uniform.$error,
                      'is-valid': !$v.uniform.$invalid,
                    }"
                  />
                  <span class="placeholder">Uniform No#</span>
                  <span v-if="!$v.uniform.required" class="invalid-tooltip">
                    Uniform No# is required
                  </span>
                </div>
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    id="bat_size"
                    v-model="bat_size"
                    @keyup="errorNull"
                    @input="handleInputChange()"
                    required
                    :class="{
                      'is-invalid': $v.bat_size.$error,
                      'is-valid': !$v.bat_size.$invalid,
                    }"
                  />
                  <span class="placeholder">Bat Size</span>
                  <span v-if="!$v.bat_size.required" class="invalid-tooltip">
                    Bat size is required
                  </span>
                </div>
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    id="bat_details"
                    v-model="bat_details"
                    @keyup="errorNull"
                    @input="handleInputChange()"
                    required
                    :class="{
                      'is-invalid': $v.bat_details.$error,
                      'is-valid': !$v.bat_details.$invalid,
                    }"
                  />
                  <span class="placeholder">Bat Load</span>
                  <span v-if="!$v.bat_details.required" class="invalid-tooltip">
                    Bat load is required
                  </span>
                </div>
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    id="hat_size"
                    v-model="hat_size"
                    @keyup="errorNull"
                    @input="handleInputChange()"
                    required
                    :class="{
                      'is-invalid': $v.hat_size.$error,
                      'is-valid': !$v.hat_size.$invalid,
                    }"
                  />
                  <span class="placeholder">Hat Size</span>
                  <span v-if="!$v.hat_size.required" class="invalid-tooltip">
                    Hat size is required
                  </span>
                </div>
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    id="shirt_size"
                    v-model="shirt_size"
                    @keyup="errorNull"
                    @input="handleInputChange()"
                    required
                    :class="{
                      'is-invalid': $v.shirt_size.$error,
                      'is-valid': !$v.shirt_size.$invalid,
                    }"
                  />
                  <span class="placeholder">Shirt Size</span>
                  <span v-if="!$v.shirt_size.required" class="invalid-tooltip">
                    Shirt size is required
                  </span>
                </div>
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    id="pant_size"
                    v-model="pant_size"
                    @keyup="errorNull"
                    @input="handleInputChange()"
                    required
                    :class="{
                      'is-invalid': $v.pant_size.$error,
                      'is-valid': !$v.pant_size.$invalid,
                    }"
                  />
                  <span class="placeholder">Pant</span>
                  <span v-if="!$v.pant_size.required" class="invalid-tooltip">
                    Pant is required
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="event-btns-wrapper justify-content-end">
            <button
              type="button"
              class="btn btn-primary"
              @click="update(0)"
              :disabled="isLoadingArray[0]"
            >
              <div v-if="isLoadingArray[0]" class="lds-dual-ring"></div>
              <div v-else>
                <img
                  class="mr-1"
                  src="../../../../assets/Svg/save.svg"
                  alt="save"
                />Save
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Update Uniform modal -->
  </div>
</template>
<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
export default {
  name: "AddUniformModal",
  props: {
    selectedRoomTeam: {
      type: Object,
    },
  },
  validations: {
    uniform: { required },
    bat_size: { required },
    bat_details: { required },
    hat_size: { required },
    shirt_size: { required },
    pant_size: { required },
  },
  data() {
    return {
      isDisabled: false,
      uniform: "",
      userChatId: {},
      bat_size: "",
      bat_details: "",
      hat_size: "",
      shirt_size: "",
      pant_size: "",
      isPlayer: false,
      imgLoader: 1,
      isLoadingArray: [],
    };
  },

  methods: {
    handleImageError(event) {
      event.target.src =
        "https://whoifollow.s3.us-west-2.amazonaws.com/chat/groupAvatar/LWE6E3CLzQZkgr56QyEmuCp8IHhut4ZddQa8qzFM.svg";
    },
    getUserImageUrl(user) {
      const imageUrl = user.user_id
        ? `${this.$userProfileStorageURL}${user.user_id}/profile_picture.jpg?v=${this.$time}`
        : "https://api.whoifollow.tech/user-default2.png";
      return imageUrl;
    },
    onImageLoad() {
      this.imgLoader = 0;
    },
    updateIsPlayer(value) {
      console.log("IsPlayer toggled:", value);
      // Toggle visibility of input fields based on `isPlayer`
    },
    // ---- Check Null ----------------------------------------------------------------------
    errorNull: function() {
      if (
        this.uniform == "" ||
        this.bat_size == "" ||
        this.bat_details == "" ||
        this.hat_size == "" ||
        this.shirt_size == "" ||
        this.pant_size == ""
      ) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
    },
    updatePlayer() {
      this.playerTag = !this.playerTag;
    },
    handleInputChange() {
      // Check if any of the input values have changed
      const isValueChanged =
        this.uniform !== this.initialUniform ||
        this.bat_size !== this.initialBatSize ||
        this.bat_details !== this.initialBatDetails ||
        this.hat_size !== this.initialHatSize ||
        this.shirt_size !== this.initialShirtSize ||
        this.pant_size !== this.initialPantSize;

      // Update the flag accordingly
      this.isDisabled = !isValueChanged;
    },

    // ---- Update ----------------------------------------------------------------------
    async update(index) {
      this.$v.$touch();
      if (this.$v.$pendding || this.$v.$error) return;
      this.$set(this.isLoadingArray, index, true);
      try {
        // Make API call to update team member sizes
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}chat/updateTeamMemberSizes`,
          {
            roomId: this.selectedRoomTeam.roomId,
            userId: this.userChatId.member.id,
            uniform: this.uniform,
            bat_details: this.bat_details,
            bat_size: this.bat_size,
            hat_size: this.hat_size,
            shirt_size: this.shirt_size,
            pant_size: this.pant_size,
            isPlayer: this.isPlayer ? 1 : 0,
          }
        );

        // If API call is successful, proceed with Firestore update
        if (response.data.statusCode === 200) {
          this.$alert("Player info has been updated successfully.");

          // Close the modal
          this.$refs.closeModalUniform.click();
          this.uniform = null;
          this.bat_size = null;
          this.bat_details = null;
          this.hat_size = null;
          this.shirt_size = null;
          this.pant_size = null;
          // Emit events for UI updates
          this.$root.$emit("gameTimeScheduledReload");
          this.$root.$emit("gameTimeTeammatesReload");
          this.$root.$emit("gameTimeStatisticsReload");
          this.$root.$emit("fetchUpdatedTeammates");
        }
      } catch (error) {
        console.error("Error updating player info:", error);
        this.$alert("Failed to update player info. Please try again.");
      } finally {
        this.$set(this.isLoadingArray, index, false);
      }
    },
  },
  mounted() {
    this.$root.$on("fetchUniformData", (userChatId) => {
      this.$v.$reset();
      this.userChatId = userChatId;
      this.uniform = userChatId.uniform_no;
      this.bat_size = userChatId.bat_size;
      this.bat_details = userChatId.bat_details;
      this.shirt_size = userChatId.shirt_size;
      this.pant_size = userChatId.pant_size;
      this.hat_size = userChatId.hat_size;
      this.isPlayer = userChatId.isPlayer === 1;
      this.errorNull();
    });
  },
};
</script>
